import { IAdpVoucherHolder } from '@nkr/models/adp-voucher-holder';
import { ColDef, ColumnApi, FirstDataRenderedEvent, AgGridEvent, ValueGetterParams, GridApi, GridReadyEvent, ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useMemo, useState } from 'react';
import { Button, Label } from 'react-bootstrap';
import RankRenderer from '../admin/center/list/common/rank-renderer';
import SortableHeaderComponent from '../admin/center/list/common/sortable-header';
import { ReportWrapper } from './styles';
import { Utility } from '@nkr/services/utility';

interface IProps {
    data: IAdpVoucherHolder[],
    onGetScreeningResults: (id: number) => void,
    onConfirmMarkReviewed: (id: number) => void,
    onClickSendEmail: (id: number) => void
}

const Grid = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [columns, setColumns] = useState<ColDef[]>([
        {
            colId: 'row',
            field: 'row',
            headerName: 'Row',
            headerClass: 'list-header',
            headerComponentParams: { columnName: 'Row' },
            headerComponentFramework: SortableHeaderComponent,
            width: 50,
            cellClass: 'list-cell',
            sortable: false,
            resizable: false,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1,
            cellRendererFramework: (params: ICellRendererParams) => <>{params.value}</>
        },
        {
            colId: 'fullName',
            field: 'fullName',
            headerName: 'Name',
            headerClass: 'list-header',
            headerComponentParams: { columnName: 'Name' },
            headerComponentFramework: SortableHeaderComponent,
            width: 150,
            cellClass: 'list-cell',
            sortable: true,
            comparator: Utility.nameComparator,
            resizable: false
        },
        {
            colId: 'registrationDate',
            field: 'registrationDate',
            headerName: 'Registration Date',
            headerClass: 'list-header',
            headerComponentParams: { columnName: 'Registration Date' },
            headerComponentFramework: SortableHeaderComponent,
            width: 150,
            cellClass: 'list-cell',
            sortable: true,
            comparator: Utility.dateComparator,
            resizable: false
        },
        {
            colId: 'lastScreeningResultsDateTime',
            field: 'lastScreeningResultsDateTime',
            headerName: 'Results Date',
            headerClass: 'list-header',
            headerComponentParams: { columnName: 'Results Date' },
            headerComponentFramework: SortableHeaderComponent,
            width: 200,
            cellClass: 'list-cell',
            sortable: true,
            comparator: Utility.dateComparator,
            resizable: false
        },
        {
            colId: 'downloadRes',
            field: 'downloadRes',
            headerName: '',
            headerClass: 'list-header',
            // headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}></SortableHeaderComponent>,
            width: 90,
            cellClass: 'list-cell',
            sortable: false,
            resizable: false,
            suppressMenu: true,
            cellRendererFramework: (params: ICellRendererParams) =>
                <Button bsStyle='primary' bsSize='xs' value='test' onClick={() => props.onGetScreeningResults(params.data.id)}> Download Results</Button>
        },
        {
            colId: 'markReviewed',
            field: 'markReviewed',
            headerName: '',
            headerClass: 'list-header',
            // headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}></SortableHeaderComponent>,
            width: 90,
            cellClass: 'list-cell',
            sortable: false,
            resizable: false,
            suppressMenu: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                if (params.data.isAbnormalScreeningReviewed) {
                    return <Label>Reviewed</Label>
                } else {
                    return <Button bsStyle='success' bsSize='xs' onClick={() => props.onConfirmMarkReviewed(params.data.id)}>Mark Reviewed</Button>
                }
            }
        },
        {
            colId: 'sendEmail',
            field: 'sendEmail',
            headerName: '',
            headerClass: 'list-header',
            // headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}></SortableHeaderComponent>,
            width: 90,
            cellClass: 'list-cell',
            sortable: false,
            resizable: false,
            suppressMenu: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                if (params.data.isAbnormalScreening == false) {
                    return <Label>Not Abnormal</Label>
                } else {
                    return <Button bsStyle='warning' bsSize='xs' onClick={() => props.onClickSendEmail(params.data.id)}>Send Email</Button>
                }
            }
        }
    ]);

    const onSortChanged = (e: AgGridEvent) => {
        e.api.refreshCells();
    }

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);
        setColumnApi(e.columnApi);

        e.api.sizeColumnsToFit();
    }

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <ReportWrapper className='ag-theme-bootstrap'>
            <AgGridReact
                rowData={rowData}
                columnDefs={columns}               
                suppressRowClickSelection={false}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onSortChanged={onSortChanged}
            />
        </ReportWrapper>
    );
}

export default Grid;